<!------------------------------------------------------------------------------
 File: SingleCountModule 
 Created by keni.
 with: IntelliJ IDEA
 Date: 20/04/2018
 Time: 17:04
------------------------------------------------------------------------------->
<template>
    <div class="single-count-module">
        <div>
            daily count
        </div>
        <div>£0.00</div>
    </div>
</template>

<script>
    export default {
        name: "single-count-module",
        components: {},
        props: [],
        created() {
        },
        destroyed() {
        },
        mounted() {

        },
        data() {
            return {}
        },
        methods: {},
        watch: {},
        computed: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/modules/SingleCountModule.vue?4c67d965